import React from "react";

import SchedulerForm from "./SchedulerForm";
import SchedulerProvider from "./SchedulerProvider";

const SchedulerPage: React.FC = () => {
  return (
    <SchedulerProvider>
      <SchedulerForm />
    </SchedulerProvider>
  );
};

export default SchedulerPage;
